import { initComponent } from './vue-helpers';
import Search from './Search.vue';
import SearchWidget from './SearchWidget.vue';
import Register from "./Register/Register.vue";
import Contact from './Contact.vue';
initComponent({
    name: 'search',
    component: Search,
    target: '.search-module',
});
initComponent({
    name: 'searchwidget',
    component: SearchWidget,
    target: '.search-widget',
});
initComponent({
    name: 'register',
    component: Register,
    target: '.register',
});
initComponent({
    name: 'Contact',
    component: Contact,
    target: '.contact-module',
});
